import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, Observable, throwError, timeout } from 'rxjs';
import { LoggingService } from '@logging/logging.service';
import { AuthState } from './models/auth.models';
import { environment } from '@env/environment';
import { SignInCredentials } from './models/auth.models';

@Injectable({ providedIn: 'root' })
export abstract class AuthorisationDataProvider {
  constructor(
    protected httpClient: HttpClient,
    protected logger: LoggingService
  ) {
  }

  protected apiRoot = `${environment.apiPaths.authorisation}SignIn`;

  signIn$(email: string, password: string, rememberMe: boolean): Observable<AuthState> {
    const credentials: SignInCredentials = {
        emailAddress: email,
        password: password,
        applicationEnvironmentId: environment.appId,
        rememberMe: rememberMe
      };
  
      this.logger.trace('AuthorisationDataProvider: sign in', email);
  
    return this.httpClient.post<AuthState>(this.apiRoot, credentials).pipe(
      timeout(30000),
      catchError(error => {
        if (error.name === 'TimeoutError') {
          this.logger.error('AuthorisationDataProvider: Request timed out');
          return throwError(() => new Error('Sign in request timed out after 30 seconds'));
        }
        this.logger.error('AuthorisationDataProvider: Error during sign in', error);
        return throwError(() => error);
      })
    );
  }

  /**
   * Sign in using a Microsoft authentication token
   * @param token The Microsoft authentication token
   * @returns Observable of AuthState
   */
  signInByToken$(token: string): Observable<AuthState> {
    const tokenSignInUrl = `${environment.apiPaths.authorisation}SignInByToken`;
    const params = new HttpParams().set('token', token);

    this.logger.trace('AuthorisationDataProvider: sign in by token');

    return this.httpClient.post<AuthState>(tokenSignInUrl, null, { params }).pipe(
      timeout(30000),
      catchError(error => {
        if (error.name === 'TimeoutError') {
          this.logger.error('AuthorisationDataProvider: Token sign in request timed out');
          return throwError(() => new Error('Token sign in request timed out after 30 seconds'));
        }
        this.logger.error('AuthorisationDataProvider: Error during token sign in', error);
        return throwError(() => error);
      })
    );
  }

} 